import React, {
    useEffect,
    useState,
    useRef,
    useCallback,
    MutableRefObject,
} from 'react';
import classnames from 'classnames';
import DropdownButton from './DropdownButton';
import DropdownContent from './DropdownContent';
import styles from './dropdown.module.scss';
import { Element } from '@zmedia/bm-soccer-ui/components';

interface IProps {
    name: string;
}

export interface IDropdown {
    children?: any;
    triggerBefore?: any;
    className?: string;
}

export function useDropdown({ name }: IProps) {
    const [isExpand, setExpand] = useState(false);
    const [buttonName, setName] = useState(name);
    const contentRef: MutableRefObject<HTMLElement | any> = useRef({});
    const btnRef: MutableRefObject<HTMLElement | any> = useRef({});

    const closeDropdown = () => {
        setExpand(false);
    };

    const openDropdown = () => {
        setExpand(true);
    };

    const toggleDropdown = useCallback(() => {
        setExpand(!isExpand);
    }, [isExpand]);

    const onMouseUp = useCallback(
        (e: MouseEvent) => {
            if (btnRef.current.contains(e.target)) {
                toggleDropdown();
            } else if (!contentRef.current.contains(e.target)) {
                closeDropdown();
            }
        },
        [contentRef, btnRef, isExpand]
    );

    useEffect(() => {
        window.addEventListener('mouseup', onMouseUp);
        return () => {
            window.removeEventListener('mouseup', onMouseUp);
        };
    }, [isExpand]);

    const Dropdown = useCallback(
        (props: IDropdown) => {
            const { className, triggerBefore = null } = props;
            return (
                <Element
                    className={classnames(styles['bm-dropdown'], className)}
                >
                    <Element
                        className={classnames(styles['bm-dropdown-trigger'])}
                    >
                        {triggerBefore}
                        <DropdownButton
                            name={buttonName}
                            isExpand={isExpand}
                            domRef={btnRef}
                        />
                    </Element>
                    <DropdownContent domRef={contentRef} isShow={isExpand}>
                        {props.children}
                    </DropdownContent>
                </Element>
            );
        },
        [isExpand, name, buttonName]
    );
    return { isExpand, openDropdown, closeDropdown, Dropdown, setName };
}

export default useDropdown;
